// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-20a60";
var _4 = "read-3KJsr";
var _5 = "header-3AmeS";
var _6 = "title-2cXTd";
var _7 = "date-20LIa";
var _8 = "details-2hH8y";
var _9 = "description-37bX5";
var _a = "image-mQLTT";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "read", _5 as "header", _6 as "title", _7 as "date", _8 as "details", _9 as "description", _a as "image" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "read": _4, "header": _5, "title": _6, "date": _7, "details": _8, "description": _9, "image": _a }
